<template>
    <div>
        <DialogoAddEdit ref="dialogoAddEdit" :tipo="type" :key="dialogoKey" />
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formSimularPlanPago" @submit.prevent="seleccionar" class="custom-content-padding">
                <v-card flat>
                    <v-card-title v-if="$vuetify.breakpoint.smAndDown"
                        class="px-5 font-weight-bold text-body-1 primary--text justify-center py-0">
                        ELEGÍ CÓMO PAGAR
                    </v-card-title>
                    <div class="d-flex flex-column justify-center pa-5">
                        <v-card class="pa-3" flat>
                            <v-row class="justify-start">
                                <v-col cols="12" md="12">
                                    <v-select v-model="tipoPago" :items="itemsTipoPago" item-text="tipPago"
                                        item-value="id" label="Seleccionar medio de pago" color="primary" dense
                                        @change="onTipoPagoChange"></v-select>
                                </v-col>
                                <v-col cols="12" md="12" v-if="tipoPago">
                                    <v-select :label="title" v-model="selectedCuenta" :items="itemSeleccion"
                                        return-object
                                        :item-text="tipoPago == 1
                                            ? (item => item.esNueva ? item.texto : `${item.deb_cbu1}${item.deb_cbu2}${item.bco_nombre ? ' - ' + item.bco_nombre : ''}`)
                                            : (item => item.esNueva ? item.texto : `${item.deb_tarjeta}${item.bco_nombre ? ' - ' + item.bco_nombre : ''}`)" />
                                </v-col>
                                <v-col cols="12" md="12" v-if="selectedCuenta.esNueva" class="pt-0 mt-0">
                                    <!-- Aviso unificado: titularidad + (solo si CBU) restriccion de billeteras
                                         virtuales. Va aca (wrapper) para no contaminar los sub-forms que se
                                         reusan en MediosDePago.vue con otra semantica. En CBU pasamos
                                         ocultarAvisoCvu=true al sub-form para que no duplique el aviso. -->
                                    <v-alert color="secondary" outlined dense icon="mdi-information-outline"
                                        class="rounded-0 mb-3">
                                        Solo se admiten <strong>cuentas bancarias o tarjetas donde seas
                                            titular</strong>. El nombre y apellido deben coincidir con los datos
                                        registrados como afiliada/o.
                                        <span v-if="tipoPago == 1">
                                            Tampoco podés adherir <strong>cuentas de
                                                billeteras virtuales no bancarizadas (CVU)</strong>.
                                        </span>
                                    </v-alert>
                                    <v-card flat class="rounded-0">
                                        <component :is="tipoPago == 1 ? 'FormEditarCuenta' : 'FormEditarTarjeta'"
                                            ref="nuevaCuenta" :ocultarAvisoCvu="tipoPago == 1"
                                            @cuentaDataChanged="onCuentaDataChanged"
                                            @validityChanged="onFormValidityChanged" />
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card>
                    </div>
                </v-card>
                <v-card-actions class="d-flex align-center custom-card-actions-ha">
                    <v-btn elevation='0' @click="volver" class="pa-5" color="secondary" outlined>
                        <v-icon class="mr-2">mdi-chevron-left</v-icon> atras
                    </v-btn>
                    <v-spacer />
                    <v-btn elevation='0' :disabled="isBotonSiguienteDisabled" type="submit" class="pa-5" color="primary"
                        :loading="loadSkeleton" @click="siguientePaso">
                        <v-icon class="mr-2">mdi-chevron-right</v-icon> siguiente
                    </v-btn>
                </v-card-actions>
            </v-form>
        </ValidationObserver>
    </div>

</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DialogoAddEdit from '@/components/dialogos/DialogoAddEdit.vue';
import FormEditarCuenta from '@/components/forms/FormEditarCuenta.vue'
import FormEditarTarjeta from '@/components/forms/FormEditarTarjeta.vue'
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'FormSeleccionarCuenta',
    components: {
        ValidationObserver,
        ValidationProvider,
        DialogoAddEdit,
        FormEditarCuenta,
        FormEditarTarjeta
    },
    data() {
        return {
            selectedCuenta: '',
            itemsTipoPago: [
                { id: 1, tipPago: 'PAGO DIRECTO CON CBU' },
                { id: 2, tipPago: 'DÉBITO CON TARJETA DE CRÉDITO VISA' },
            ],
            activos: [],

            tipoPago: '',
            selected: [],
            cuentas: [],
            headersDebito: [
                { text: 'CBU', value: 'deb_cbu1', align: 'center', class: 'primary--text' },
                { text: 'BANCO EMISOR', value: 'bco_nombre', align: 'center', class: 'primary--text' },
                { text: 'ACCIONES', value: 'actions', align: 'center', sortable: false, class: 'primary--text' }
            ],
            headersVisa: [
                { text: 'NÚMERO DE TARJETA', value: 'deb_tarjeta', align: 'center', class: 'primary--text' },
                { text: 'BANCO EMISOR', value: 'bco_nombre', align: 'center', class: 'primary--text' },
                { text: 'FECHA DE VENCIMIENTO', value: 'deb_fecvenc', align: 'center', class: 'primary--text', width: '50px' },
                { text: 'TITULAR', value: 'deb_tit_nombre', align: 'center', class: 'primary--text' },
                { text: 'ACCIONES', value: 'actions', align: 'center', sortable: false, class: 'primary--text' }
            ],
            isNuevaCuentaValid: false
        };
    },
    methods: {
        ...mapActions('mediosDePago', ['aportesActivos', 'guardarActivos', 'guardarCuenta']),
        ...mapActions('dataUser', ['addFiles']),
        onTipoPagoChange() {
            // Limpiar selección al cambiar tipo de pago y estado de validación
            this.selectedCuenta = '';
            this.isNuevaCuentaValid = false;
            // Limpiar el comprobante almacenado en dataUser
            this.addFiles({ op: 'comprobanteCbu', file: '' });
        },
        addCuenta() {
            // Método llamado cuando se agrega una cuenta/tarjeta exitosamente
            // Volver al listado correspondiente
            if (this.tipoPago == 3) {
                this.tipoPago = 1; // Volver a listado de cuentas CBU
            } else if (this.tipoPago == 4) {
                this.tipoPago = 2; // Volver a listado de tarjetas
            }
            this.selectedCuenta = null; // Limpiar selección
        },
        onCuentaDataChanged(cuentaData) {
            // Actualizar selectedCuenta con los datos del formulario hijo
            if (this.selectedCuenta && this.selectedCuenta.esNueva) {
                // Mantener la misma referencia para que v-select no pierda el vínculo
                Object.assign(this.selectedCuenta, cuentaData)
            }
        },

        volver() {
            this.$emit('volver');
            this.selectedCuenta = ''; // Limpiar selección
            this.tipoPago = '';
            this.addFiles({ op: 'comprobanteCbu', file: '' });
        },
        formatTarjeta(numero) {
            if (!numero) return '';
            // Elimina cualquier caracter no numérico y agrupa en bloques de 4
            return numero.replace(/\D/g, '').replace(/(.{4})/g, '$1 ').trim();
        },
        async siguientePaso() {
            // Si es cuenta nueva, validar antes de continuar
            if (this.selectedCuenta.esNueva && this.$refs.nuevaCuenta) {
                // Validar el formulario del componente hijo
                const isValid = await this.$refs.nuevaCuenta.$refs.obs.validate();

                if (!isValid) {
                    // Mostrar mensaje o forzar scroll al error
                    this.$refs.nuevaCuenta.forzarValidacion();
                    return;
                }
            }
            this.guardarCuenta(this.selectedCuenta);

            //this.guardarActivos(this.activos);
            console.log('Cuenta seleccionada: ', this.selectedCuenta);
            this.$emit('siguiente');
        },
        onFormValidityChanged(isValid) {
            this.isNuevaCuentaValid = isValid;
        },
    },
    computed: {
        ...mapGetters('mediosDePago', ['tiposMediosPagos', 'pp_aux', 'idPrePlanPago']),
        isBotonSiguienteDisabled() {
            // Si no hay cuenta seleccionada o no hay tipo de pago
            if (!this.selectedCuenta || !this.tipoPago) {
                return true;
            }
            // Si es una cuenta nueva, verificar validación del formulario
            if (this.selectedCuenta.esNueva) {
                return !this.isNuevaCuentaValid;
            }
            // Si es una cuenta existente, permitir continuar
            return false;
        },

        itemSeleccion() {
            let items = [];

            if (this.tipoPago == 1) {
                // Obtener cuentas existentes
                items = [...(this.tiposMediosPagos.cbu || [])];

                // Agregar opción "Nueva cuenta"
                items.push({
                    id: 'nueva_cuenta',
                    esNueva: true,
                    texto: 'NUEVA CUENTA',
                    deb_cbu1: '',
                    deb_cbu2: '',
                    bco_nombre: '',
                    deb_estado: "PA",
                });

                return items;
            } else if (this.tipoPago == 2) {
                // Obtener tarjetas existentes
                items = [...(this.tiposMediosPagos.visa || [])];

                // Agregar opción "Nueva tarjeta"
                items.push({
                    id: 'nueva_tarjeta',
                    esNueva: true,
                    texto: 'NUEVA TARJETA',
                    deb_tarjeta: '',
                    deb_banco: '',
                    bco_nombre: ''
                });

                return items;
            }
            //return [];
        },
        title() {
            if (this.tipoPago == 1) {
                return 'Mis cuentas';
            } else if (this.tipoPago == 2) {
                return 'Mis tarjetas';
            }
            return '';
        },
        destinoPP() {
            return (this.tipoPago == 1) ? `CBU ${this.selectedCuenta.deb_cbu1}${this.selectedCuenta.deb_cbu2}` : `TARJ ${this.selectedCuenta.deb_tarjeta}`;
        }
    },
    watch: {
        selectedCuenta(newVal) {
            console.log('selectedCuenta changed:', newVal);

            this.aportesActivos()
            this.activos = {
                abr: "PX",
                nro: this.idPrePlanPago,
                dest: this.destinoPP
            }
            console.log(this.activos)
            // Detectar si se seleccionó "nueva cuenta" o "nueva tarjeta"
            if (newVal && newVal.esNueva) {
                if (this.tipoPago == 1) {
                    // Mostrar formulario para nueva cuenta CBU
                    //this.tipoPago = 3; // Cambia a modo formulario
                } else if (this.tipoPago == 2) {
                    // Mostrar formulario para nueva tarjeta
                    //this.tipoPago = 4; // Cambia a modo formulario
                }
            } else {
                console.log('Cuenta seleccionada:', newVal);
            }
            this.isNuevaCuentaValid = newVal && !newVal.esNueva;
        }
    }

};
</script>

<style scoped>
.custom-card-actions-ha {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    padding: 0 16px;
    z-index: 5;
}

.custom-content-padding {
    padding-bottom: 0px !important;
}
</style>